export const RESET_OPPORTUNITY_STORE = "RESET_OPPRTUNITY_STORE";

export const resetOpportunityStore = () => ({
  type: RESET_OPPORTUNITY_STORE,
});

export * from "./list-actions";
export * from "./response-list-actions";
